import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export const fieldsNlpIntent = _extends({}, fieldsIBaseModel, {
  entities: {
    type: 'ID',
    ref: EModel.NlpIntentEntity,
    array: true
  },
  intent: {
    type: 'Text'
  },
  key: {
    type: 'Text'
  },
  ref: {
    type: 'Text'
  },
  type: {
    type: 'Text'
  },
  utterances: {
    type: 'ID',
    ref: EModel.Utterance,
    array: true
  }
});